import DevisForm from "@/components/DevisForm";
import { MaskedLineScroll, Overline } from "@/components/Reveal";

export default function DevisSection() {
  return (
    <section id="contact" className="bg-bone py-24 md:py-32" data-testid="devis-section">
      <div className="max-w-7xl mx-auto px-5 md:px-10">
        <div className="mb-16">
          <Overline>Contact — Devis gratuit</Overline>
          <h2 className="mt-4 font-display font-black uppercase tracking-tighter leading-[0.95] text-3xl sm:text-4xl lg:text-5xl">
            <MaskedLineScroll>Demandez votre</MaskedLineScroll>
            <MaskedLineScroll delay={0.12}><span className="text-signal">devis gratuit</span></MaskedLineScroll>
          </h2>
        </div>
        <DevisForm />
      </div>
    </section>
  );
}
